import { LogoutOutlined, UserOutlined, DownOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Button, Dropdown, Menu, Avatar } from "antd";
import { AppDispatch } from "shared/store/root.store";
import { AuthSliceMethods, getAuthState } from "features/auth/model/authSlice";
import { useState } from "react";
import styles from "./styles.module.css";
import { Paths } from "shared/config/paths";
import { useTranslation } from "react-i18next";
import { createPortal } from "react-dom";

export const AuthButtons = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { isLoggedIn, secondName, name } = useSelector(getAuthState);

  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  const showLogoutModal = () => {
    setIsLogoutModalVisible(true);
  };

  const handleLogoutConfirm = () => {
    setIsLogoutModalVisible(false);
    dispatch(AuthSliceMethods.logout());
    navigate("/");
  };

  const handleLogoutCancel = () => {
    setIsLogoutModalVisible(false);
  };

  const menu = (
    <Menu>
      <Menu.Item
        key="logout"
        icon={<LogoutOutlined style={{ color: "red" }} />}
        onClick={showLogoutModal}
      >
        <span style={{ color: "red" }}>{t("auth.exit")}</span>
      </Menu.Item>
    </Menu>
  );

  const userInitials = `${name?.[0] || ""}${secondName?.[0] || ""}`;
  const fullName = `${name || ""} ${secondName || ""}`;

  return (
    <>
      {isLoggedIn ? (
        <Dropdown overlay={menu} placement="bottomRight" trigger={["click"]}>
          <div className={styles.userProfile}>
            <Avatar className={styles.avatar} size={32}>
              <UserOutlined style={{ fontSize: 32 }} />
            </Avatar>
            <div className={styles.userInfo}>
              <span className={styles.userName}>{fullName}</span>
            </div>
            <DownOutlined className={styles.downIcon} />
          </div>
        </Dropdown>
      ) : (
        <>
          <Button
            className={styles.loginButton}
            onClick={() => navigate(Paths.login)}
          >
            {t("auth.logon")}
          </Button>
          {/* <Button className={styles.registerButton} onClick={() => navigate(Paths.signup)}>
            {t('auth.register')}
          </Button> */}
        </>
      )}

      {isLogoutModalVisible &&
        createPortal(
          <div className={styles.customModalOverlay}>
            <div className={styles.customModal}>
              <h3>{t("auth.logout_confirmation_message")}</h3>
              <p>{t("auth.logout_confirmation_title")}</p>
              <div className={styles.modalButtons}>
                <button
                  onClick={handleLogoutConfirm}
                  className={styles.confirmButton}
                >
                  {t("auth.yes")}
                </button>
                <button
                  onClick={handleLogoutCancel}
                  className={styles.cancelButton}
                >
                  {t("auth.no")}
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};
